import CommentSectionModal from "@/app/components/routes/auth_routes/SlotsScreen/CommentSection";

interface CommentsCardProps {
  completedBookingFlow: boolean;
  resolvedDiscountCouponLabel: string;
  isHomeServiceBooking: boolean;
  commentsData: any;
  additionalCommentsList: string[];
}

const CommentsCard = ({
  completedBookingFlow,
  resolvedDiscountCouponLabel,
  isHomeServiceBooking,
  commentsData,
  additionalCommentsList,
}: CommentsCardProps) => {
  return (
    <section className="rounded-2xl border border-[#E4E7ED] bg-white p-3 shadow-[0_2px_10px_rgba(17,24,39,0.05)]">
      <div className="mb-3 flex items-center justify-between">
        <h3 className="text-[14px] font-semibold leading-6 text-[#222222]">Comments</h3>
        {!completedBookingFlow && (
          <span>
            <CommentSectionModal commentEdit={true} isCommentModalEdit={true} />
          </span>
        )}
      </div>
      <div className="space-y-2.5 text-[12px]">
        <div className="flex items-center justify-between gap-3">
          <p className="text-[#6D6D6D] font-medium">Discount Coupon</p>
          <p className="text-right font-medium text-[#222222]">{resolvedDiscountCouponLabel}</p>
        </div>
        {isHomeServiceBooking && (
          <div className="flex items-center justify-between gap-3">
            <p className="text-[#6D6D6D] font-medium">Reason For Appointment</p>
            <p className="text-right font-medium text-[#222222]">{commentsData?.reason || "NA"}</p>
          </div>
        )}
        <div className="flex items-center justify-between gap-3">
          <p className="text-[#6D6D6D] font-medium">Vaccination Diary</p>
          <p className="text-right font-medium text-[#222222]">{commentsData?.vaccination ? "Yes" : "No"}</p>
        </div>
        <div className="rounded-[8px] bg-[#F0F0F0] p-[8px]">
          <p className="mb-1.5 text-[12px] font-medium text-[#222222]">Additional Comments</p>
          <ul className="list-disc space-y-1 pl-5 text-[12px] text-[#222222] marker:text-[#222222]">
            {additionalCommentsList.map((comment, index) => (
              <li key={`${comment}-${index}`}>{comment}</li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default CommentsCard;
